import React from 'react'
import "./Explore_game_banner.css"
import Yellow_arrow_btn from '../../common_components/common_btn/yellow_arrow_btn/Yellow_arrow_btn'
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/pagination';
import { Pagination } from 'swiper/modules';
import { useNavigate } from 'react-router-dom';
function Explore_game_banner() {
    const navigate = useNavigate();
    return (
        <>
            <section className='Explore_game_banner_holder'>
                <Swiper pagination={true} modules={[Pagination]} className=" Explore_banner_slider" slidesPerView={1} >
                    <SwiperSlide>
                        <div className='Explore_game_banner'>
                            <div className="banner_img_holder">
                                <img src="/assets/images/home/Explore_more_with_us/explore_game_banner/banner.png" alt="" className='explore_img' />
                            </div>

                            <div className="taxt_btn_holder">
                                <h1>Spin the Wheel, Roulette Thrills Await You</h1>
                                <Yellow_arrow_btn
                                    btnText="Explore Game Now"
                                    onClick={() => navigate("/explore-game/onetouch-roulette")}
                                />
                            </div>
                        </div>
                    </SwiperSlide>

                </Swiper>

            </section>

        </>
    )
}

export default Explore_game_banner